module.exports = __webpack_public_path__ + "static/media/medica-logo-transparent.73869d1f.png";